import {
  setNewAccessTokenError,
  setNewAccessTokenStart,
  setNewAccessTokenSuccess
} from 'store/actions/auth'
import config from '../config'
import axiosPrivateInstance from './AxiosInstance'

const AxiosInterceptors = (store, persistor) => {
  axiosPrivateInstance.interceptors.request.use(async instanceConfig => {
    const token = await store.getState().auth.token
    if (token) {
      instanceConfig.headers.authorization = `Bearer ${token}`
    }
    return instanceConfig
  })

  axiosPrivateInstance.interceptors.response.use(
    res => res,
    async error => {
      const prevRequest = error?.config
      if (prevRequest.skipAuthRetry) return Promise.reject(error)
      if (prevRequest.url !== `${config.baseUrl}/login` && error.response) {
        if (error.response.status === 401 && !prevRequest?.sent) {
          prevRequest.sent = true
          try {
            await store.dispatch(setNewAccessTokenStart())
            const refreshTokenResponse = await axiosPrivateInstance.post('/refresh-token')
            const { token: newAccessToken } = refreshTokenResponse.data.data
            await store.dispatch(setNewAccessTokenSuccess(newAccessToken))
            return axiosPrivateInstance(prevRequest)
          } catch (_error) {
            await store.dispatch(setNewAccessTokenError())
            // O redirect abaixo recarrega a página, e o redux-persist grava de
            // forma assíncrona: sem esperar a gravação, o token morto continua
            // no localStorage, é reenviado no próximo boot e cai aqui de novo —
            // a tela de login fica recarregando em loop. O flush garante que a
            // sessão limpa chegue ao disco antes de sairmos da página.
            try {
              await persistor?.flush()
            } catch {
              // se o flush falhar, ainda assim precisamos sair para o login
            }
            window.location.href = '/login'
            return Promise.reject(_error)
          }
        }
      }
      return Promise.reject(error)
    }
  )
}

export default AxiosInterceptors
